import React, { useState, useEffect } from "react";
import { Box, Grid, TextField } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  getCounterSalesReport,
} from "./reportsApi";

const DateComponent = ({
  setCounterSales,
  SelectedStartDate, setSelectedStartDate,
  SelectedEndDate, setSelectedEndDate,
  setDate,
  setDisplayEndDate,
  setstartDateFormat,
  setEndDate,
  dateFocused, setDateFocused,
}) => {
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);

  // Format date as DD-MM-YYYY
  const formatDisplay = (date) => date ? dayjs(date).format("DD-MM-YYYY") : "";

  // Format date as YYYY-MM-DD for payload
  const formatPayload = (date) => date ? dayjs(date).format("YYYY-MM-DD") : "";

  const datePickerOnChange = (val) => {
    setSelectedStartDate(val);
    setDate(formatDisplay(val));
    setstartDateFormat(formatPayload(val));
    // Optionally reset end date if before start
    if (SelectedEndDate && val && dayjs(val).isAfter(SelectedEndDate)) {
      setSelectedEndDate(null);
      setDisplayEndDate("");
      setEndDate("");
    }
    setStartDateOpen(false);
    setEndDateOpen(true); // Open end date after picking start
  };

  const datePickerOnChangeEnd = (val) => {
    setSelectedEndDate(val);
    setDisplayEndDate(formatDisplay(val));
    setEndDate(formatPayload(val));
    setEndDateOpen(false);
  };

  useEffect(() => {
    if (SelectedStartDate && SelectedEndDate) {
      getCounterSalesReport({
        fromDate: formatPayload(SelectedStartDate),
        toDate: formatPayload(SelectedEndDate),
      })
        .then((res) => setCounterSales(res?.data?.data))
        .catch((err) => console.log("err ", err));
    }
  }, [SelectedStartDate, SelectedEndDate, setCounterSales]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Date"
          size="small"
          value={
            SelectedStartDate && SelectedEndDate
              ? `${formatDisplay(SelectedStartDate)} to ${formatDisplay(
                  SelectedEndDate
                )}`
              : SelectedStartDate
              ? `${formatDisplay(SelectedStartDate)}`
              : ""
          }
          placeholder="Select date range"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <CalendarMonthIcon
                sx={{
                  cursor: "pointer",
                  mr: 1,
                }}
                onClick={() => setStartDateOpen(true)}
              />
            ),
            sx: {
              background: "#fff",
              borderRadius: 1,
              cursor: "pointer",
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 500,
              border: "none",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
              "& fieldset": { border: "none" },
            },
          }}
          onClick={() => setStartDateOpen(true)}
          onFocus={() => setDateFocused(true)}
          onBlur={() => setDateFocused(false)}
          sx={{ width: "100%" }}
        />

        <Box sx={{ position: "relative" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              open={startDateOpen}
              onOpen={() => setStartDateOpen(true)}
              onClose={() => setStartDateOpen(false)}
              value={SelectedStartDate}
              onChange={datePickerOnChange}
              maxDate={SelectedEndDate || dayjs()}
              slotProps={{
                popper: {
                  placement: "bottom-start",
                  anchorEl: document.querySelector(
                    'input[placeholder="Select date range"]'
                  ),
                  sx: { zIndex: 1500 },
                },
                textField: { style: { display: "none" } },
              }}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              open={endDateOpen}
              onOpen={() => setEndDateOpen(true)}
              onClose={() => setEndDateOpen(false)}
              value={SelectedEndDate}
              onChange={datePickerOnChangeEnd}
              minDate={SelectedStartDate || undefined}
              slotProps={{
                popper: {
                  placement: "bottom-start",
                  anchorEl: document.querySelector(
                    'input[placeholder="Select date range"]'
                  ),
                  sx: { zIndex: 1500 },
                },
                textField: { style: { display: "none" } },
              }}
            />
          </LocalizationProvider>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DateComponent;
